module.exports = __webpack_public_path__ + "static/media/logo_square.d29dd339.png";